import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const signInSearchSchema = z.object({
  callbackUrl: z.string().optional()
})

export const Route = createFileRoute('/_auth/sign-in')({
  validateSearch: signInSearchSchema,
  beforeLoad: ({ search }) => {
    const callbackUrl = search.callbackUrl
      ? `&callbackUrl=${encodeURIComponent(search.callbackUrl)}`
      : ''
    throw redirect({ href: `/?modal=sign-in${callbackUrl}` })
  }
})
